import { useEffect, useState } from "react";
import axiosInstance from "../../../Configuration/axiosInstance";
import SalesTable from "../SalesTable/SalesTable";
import { useNavigate } from "react-router-dom";
import SearchStrip from "../../../Components/SalesOrder/SearchStrip/SearchStrip";
import LoadingSpinner from "../../../Components/Shared/Loader/Loader";

const CompletedOrders = () => {
  const [orders, setOrders] = useState([]);
  const [custId, setCustID] = useState();
  const [customers, setCustomers] = useState();
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [changed, setDataChanged] = useState(false);
  const [date, setDate] = useState();
  const [count, setCount] = useState();
  const [clearFilters, setClearFilters] = useState(false);
  const [dialogBox, setDialogBox] = useState(false);
  const [msg, setMsg] = useState("");
  const [size, setSize] = useState(20);
  const [orderNumber, setOrderNumber] = useState();

  const [searchCriteria, setSearchCriteria] = useState({
    date: null,
    custId: null,
  });

  const customerOptions = customers?.map((i) => ({
    value: i._id,
    label: i.businessName,
  }));

  const status = ["Completed"];

  const tableHeaders = [
    "Order Number",
    "Customer Name",
    "Purchase Order No.",
    "Comments",
    "SKU's",
    "Order Date(dd/mm/yyyy)",
    "Order Type",
    "Payment Type", // ✅ new
    "Payment Collected",
    "Order Status",
    "Images",
    "Driver Comments",
    "Action",
  ];

  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        setLoading(true);
        console.log(pageSize);
        const [ordersResponse, customersResponse] = await Promise.all([
          axiosInstance.get(
            `order?page=${page}&limit=${pageSize}&status=${status}&customer=${searchCriteria.custId}&date=${searchCriteria.date}&orderNumber=${searchCriteria.orderNumber}`
          ),
          axiosInstance.get(`customers/allcustomers`),
        ]);
        console.log(ordersResponse.data.data);
        setOrders(ordersResponse.data.data);
        setCount(ordersResponse.data.count);
        setCustomers(customersResponse.data.data);
        setLoading(false);
      } catch (err) {
        alert(err);
      }
    };

    fetchInitialData();
  }, [page, pageSize, changed]);

  const handleNext = () => {
    setPage((preValue) => preValue + 1);
  };
  const handlePrevious = () => {
    setPage((preValue) => preValue - 1);
  };
  const navigate = useNavigate();
  const updateOrder = (i) => {
    navigate("/salesOrders/updateOrder", { state: i });
  };

  const deleteOrder = (i) => {
    try {
      axiosInstance
        .delete(`order/${i}`)
        .then((response) => {
          setDataChanged(!changed);
        })
        .catch((error) => {});
    } catch (error) {
      alert("Caught an exception:", error);
    }
  };

  return (
    <div>
      <h2>Completed Orders</h2>

      <SearchStrip
        size={size}
        setSize={setSize}
        setPageSize={setPageSize}
        pageSize={pageSize}
        setPage={setPage}
        setDate={setDate}
        setSearchCriteria={setSearchCriteria}
        date={date}
        custId={custId}
        clearFilters={clearFilters}
        setDataChanged={setDataChanged}
        setClearFilters={setClearFilters}
        setCustID={setCustID}
        changed={changed}
        customerOptions={customerOptions}
        searchCriteria={searchCriteria}
        customers={customers}
        orderNumber={orderNumber}
        setOrderNumber={setOrderNumber}
      />
      {loading ? (
        <LoadingSpinner />
      ) : (
        <SalesTable
          orders={orders}
          setOrders={setOrders}
          updateOrder={updateOrder}
          deleteOrder={deleteOrder}
          handlePrevious={handlePrevious}
          handleNext={handleNext}
          page={page}
          pageSize={pageSize}
          count={count}
          tableHeaders={tableHeaders}
          showPaymentColumns={true}
          showDriverCommentColumns={true}
        />
      )}
    </div>
  );
};
export default CompletedOrders;
